import { render, staticRenderFns } from "./workItemsRelease.vue?vue&type=template&id=fe50ca58"
import script from "./workItemsRelease.vue?vue&type=script&lang=ts"
export * from "./workItemsRelease.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports